<div class="d-flex align-items-center">
	<div class="flex-shrink-0 me-2">
		@if (avatarImageUrl) {
			<img [src]="avatarImageUrl" (error)="onImageError()" alt="" class="avatar-xs rounded-circle shadow" />
		} @else {
			<img src="./assets/images/users/avatar.jpg" alt="" class="avatar-xs rounded-circle shadow" />
		}
	</div>

	@if (nom) {
		<div class="flex-grow-1">{{ nom }}</div>
	}
</div>
